import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Çeviri dosyalarını import ediyoruz
import trCommon from "./locales/tr/common.json";
import enCommon from "./locales/en/common.json";
import trCommon2 from "./locales/tr/common2.json";
import enCommon2 from "./locales/en/common2.json";
import trAccounting from "./locales/tr/accounting.json";
import enAccounting from "./locales/en/accounting.json";
import trHumanResources from "./locales/tr/humanResources.json";
import enHumanResources from "./locales/en/humanResources.json";
import trCardManagement from "./locales/tr/cardManagement.json";
import enCardManagement from "./locales/en/cardManagement.json";
import trSalesSystem from "./locales/tr/salesSystem.json";
import enSalesSystem from "./locales/en/salesSystem.json";
import trOther from "./locales/tr/other.json";
import enOther from "./locales/en/other.json";
import trBranches from "./locales/tr/branches.json";
import enBranches from "./locales/en/branches.json";
import trWarehouse from "./locales/tr/warehouse.json";
import enWarehouse from "./locales/en/warehouse.json";
import trProduction from "./locales/tr/production.json";
import enProduction from "./locales/en/production.json";
import trLots from "./locales/tr/lots.json";
import enLots from "./locales/en/lots.json";
import trGuides from "./locales/tr/guides.json";
import enGuides from "./locales/en/guides.json";

// Dil kaynaklarını birleştiriyoruz
const resources = {
  tr: {
    common: trCommon,
    common2: trCommon2,
    accounting: trAccounting,
    humanResources: trHumanResources,
    cardManagement: trCardManagement,
    salesSystem: trSalesSystem,
    other: trOther,
    branches: trBranches,
    warehouse: trWarehouse,
    production: trProduction,
    lots: trLots,
    guides: trGuides,
  },
  en: {
    common: enCommon,
    common2: enCommon2,
    accounting: enAccounting,
    humanResources: enHumanResources,
    cardManagement: enCardManagement,
    salesSystem: enSalesSystem,
    other: enOther,
    branches: enBranches,
    warehouse: enWarehouse,
    production: enProduction,
    lots: enLots,
    guides: enGuides,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "tr",
    // ⚠️ KRİTİK: Yalnız 'tr' ve 'en' desteklenir; tarayıcıdan gelen "tr-TR" /
    // "en-US" gibi bölgeli kodlar taban koda indirgenir. Aksi halde
    // i18n.language "tr-TR" kalıyor ve kodda yapılan `i18n.language === 'tr'`
    // karşılaştırmaları false dönüp arayüzün bir kısmını İngilizce gösteriyordu
    // (localStorage temizlendikten sonraki ilk açılışta tekrarlayan hata).
    supportedLngs: ["tr", "en"],
    load: "languageOnly",
    debug: process.env.NODE_ENV === "development",
    ns: ["common", "common2", "accounting", "humanResources", "cardManagement", "salesSystem", "other", "branches", "warehouse", "production", "lots", "guides"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      // "tr-TR" → "tr", "en-US" → "en" (hem navigator hem eski localStorage
      // kayıtları için normalize eder)
      convertDetectedLanguage: (lng: string) => lng.toLowerCase().split("-")[0]
    }
  });

export default i18n; 